import moment from 'moment';
import { useEffect, useState } from 'react';

export const useCheckLastUpdate = (initialDate: string) => {
  const [dateIsOld, setDateIsOld] = useState<boolean>(false);

  useEffect(() => {
    const interval = setInterval(() => {
      checkIfOld();
    }, 5000);

    const checkIfOld = () => {
      const now = moment();
      const lastUpdate = moment(initialDate);
      if (lastUpdate.isBefore(now, 'minute')) {
        setDateIsOld(true);
        clearInterval(interval);
      } else {
        setDateIsOld(false);
      }
    };

    checkIfOld();

    return () => clearInterval(interval);
  }, [initialDate]);

  return dateIsOld;
};
